import React, { forwardRef, useRef } from 'react'
import { RiSendPlane2Fill, RiSendPlaneFill } from 'react-icons/ri'
import Lottie from 'react-lottie'
import WrittingAnimation from '../../assets/animations/writing-animation.json'

const SendMessage = forwardRef<HTMLInputElement | null, ISendMessage>(
  ({ onSend, isDisabled, loading }, ref) => {
    // const ref = useRef<HTMLInputElement|null>(null)

    const handleKeyPress = (event) => {
      if (event.keyCode === 13 && !isDisabled) {
        onSend()
      }
    }

    return (
      <div
        style={{ backgroundColor: '#9D9CB21A', height: 60, borderRadius: 8 }}
        className="flex justify-between items-center p-5"
      >
        <input
          onKeyDown={handleKeyPress}
          ref={ref}
          placeholder="Escribe tu mensaje"
          style={{ backgroundColor: 'transparent', outline: 'none', border: 'none' }}
          className="w-full mr-5 focus:outline-none focus:ring-0"
        />
        {loading ? (
          <Lottie
            width={30}
            height={30}
            options={{
              loop: true,
              autoplay: true,
              animationData: WrittingAnimation,
              rendererSettings: { className: 'cursor-default' },
            }}
          />
        ) : (
          <RiSendPlane2Fill
            size={30}
            style={{ color: isDisabled ? 'gray' : '#006AEA' }}
            onClick={() => !isDisabled && onSend()}
            className={`${isDisabled ? '' : 'cursor-pointer'}`}
          />
        )}
      </div>
    )
  }
)

interface ISendMessage {
  onSend: () => void
  isDisabled: boolean
  loading: boolean
}

export default SendMessage
